import {AssociarPermissaoRolesPage} from "@components/seguranca/pages/AssociarPermissaoRolesPage.js";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import React, {useState} from "react";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {CreateRoleComponent} from "@components/roles/CreateRoleComponent.tsx";
import {RolesComponentDataGrid} from "@components/roles/RolesComponent.tsx";
import {Button, Tab, Tabs} from "@mui/material";
import {UsuariosPage} from "@components/usuario/pages/UsuariosPage.tsx";
import {useUsuario} from "@components/usuario/hooks/useUsuario.ts";

export const GerenciamentoUsuariosPage = () => {
    enum tabType {
        Contas,
        Roles,
        AssociarRoles
    }

    const [tab, setTab] = useState<tabType>(tabType.Contas)
    const {addPopUp, closePopUp, createAlertFromResponse} = useAlert()

    const {purgeCache} = useUsuario()

    const setPopUpCriaRoleHandler = () => {
        addPopUp({
            title: 'Criar Nova Role',
            content: <CreateRoleComponent onCreate={() => closePopUp()}/>,
            size: 'md'
        })
    }

    return (
        <DefaultContainer titulo={'Gerenciamento de usuarios e roles'}>
            <Button variant={'outlined'} onClick={setPopUpCriaRoleHandler}>
                Criar Role
            </Button>
            <Button onClick={() => {
                purgeCache().then(x => {
                    createAlertFromResponse(x)
                })
            }}>Limpar caches</Button>

            <Tabs value={tab} onChange={(_e, v: tabType) => setTab(v)}>
                {/*<Tab disabled>*/}
                {/*    <Apps/>*/}
                {/*</Tab>*/}
                <Tab value={tabType.Contas} label={'Contas'}/>
                <Tab value={tabType.Roles} label={'Roles'}/>
                <Tab value={tabType.AssociarRoles} label={'Associar Roles'}/>
            </Tabs>
            {tab === tabType.Contas && <UsuariosPage hideHeader/> ||
                tab === tabType.Roles && <RolesComponentDataGrid/> ||
                tab === tabType.AssociarRoles && <AssociarPermissaoRolesPage/>
            }
        </DefaultContainer>
    )
}